goog.provide("shadow.js.shim.module$$mui$material$Breadcrumbs$default");
shadow.js.shim.module$$mui$material$Breadcrumbs$default = shadow.js.shim.module$$mui$material$Breadcrumbs.default;
